import React from "react";

export default function Modal({ children, onClose, size = "md", testid }) {
  const widthMap = { sm: "sm:max-w-md", md: "sm:max-w-xl", lg: "sm:max-w-2xl" };
  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center sm:p-6"
      onClick={onClose}
      data-testid={testid}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-white w-full ${widthMap[size]} sm:rounded-2xl rounded-t-3xl p-5 sm:p-7 max-h-[90vh] overflow-y-auto`}
      >
        {children}
      </div>
    </div>
  );
}
